module.exports = __webpack_public_path__ + "img/GERA_Inside_Overlay_Pic1.jpg";